import React from 'react';
import { Card, CardBody, Row, Col, Button } from "reactstrap";
import { Textbox } from "react-inputs-validation";

const RenovacionPymes = ({
    dataRenovacion,
    obtenerNombreODenominacion,
    onClickAtras
}) => {
    return (
        <Col lg={8} md={12} sm={12} xs={12} className="detalle-cotizacion-box">
            <Card className="flex-row">
                <CardBody>
                    <h4 style={{ fontWeight: "bold" }}>Datos del contratante</h4>
                    <p />
                    <Row>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <h5 style={{ fontWeight: "bold" }}>Identificación</h5>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <Textbox
                                classNameInput="input-type-label form-control"
                                value={
                                    (dataRenovacion.reDatosAsegurado && dataRenovacion.reDatosAsegurado.reIdentificacion) ||
                                    (dataRenovacion.reDatosAsegurado && dataRenovacion.reDatosAsegurado.reCodigoCliente) ||
                                    ""
                                }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <h5 style={{ fontWeight: "bold" }}>Nombre completo</h5>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <Textbox
                                classNameInput="input-type-label form-control"
                                value={obtenerNombreODenominacion(dataRenovacion.reDatosAsegurado)}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <h5 style={{ fontWeight: "bold" }}>Ramo</h5>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <Textbox
                                classNameInput="input-type-label form-control"
                                value={dataRenovacion.polDescripcionRamo || (dataRenovacion.reDatosProducto && dataRenovacion.reDatosProducto.reRamo) || dataRenovacion.ramo || ""}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <h5 style={{ fontWeight: "bold" }}>Sucursal</h5>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <Textbox
                                classNameInput="input-type-label form-control"
                                value={dataRenovacion.sucursal || (dataRenovacion.reDatosBroker && dataRenovacion.reDatosBroker.rebrokersucursal) || ""}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <h5 style={{ fontWeight: "bold" }}>Dirección</h5>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <Textbox
                                classNameInput="input-type-label form-control"
                                value={(dataRenovacion.reDatosAsegurado && dataRenovacion.reDatosAsegurado.reDireccion) || ""}
                            />
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            <Button
                className="btn btn-primary"
                onClick={onClickAtras}
                style={{ display: "block", margin: "0", marginBottom: 20 }}>
                <i className='fa fa-chevron-circle-left' aria-hidden='true' />{" "}
                {"ATRÁS"}
            </Button>
        </Col>
    );
};

export default RenovacionPymes;
